up.macro('a[aria-label], button[aria-label]', (element) => {
  const $element = $(element)

  $element.attr({ 'title': $element.attr('aria-label') })
})
